export default {
  allSuppliers: [],
  supplier: {},
}
